export default __webpack_public_path__ + "static/media/missing.6f322e20.svg";